import type { Bounds2D, Point2D } from '../models/types';

export const rotatePoint = (point: Point2D, pivot: Point2D, angleDeg: number): Point2D => {
  if (!angleDeg) return point;

  const angleRad = (angleDeg * Math.PI) / 180;
  const cos = Math.cos(angleRad);
  const sin = Math.sin(angleRad);
  const dx = point.x - pivot.x;
  const dy = point.y - pivot.y;

  return {
    x: pivot.x + dx * cos - dy * sin,
    y: pivot.y + dx * sin + dy * cos,
  };
};

export const rotateBounds = (
  bounds: Bounds2D,
  pivot: Point2D,
  angleDeg: number
) => {
  if (!angleDeg) return bounds;

  const corners = [
    rotatePoint({ x: bounds.minX, y: bounds.minY }, pivot, angleDeg),
    rotatePoint({ x: bounds.maxX, y: bounds.minY }, pivot, angleDeg),
    rotatePoint({ x: bounds.maxX, y: bounds.maxY }, pivot, angleDeg),
    rotatePoint({ x: bounds.minX, y: bounds.maxY }, pivot, angleDeg),
  ];

  let minX = corners[0].x;
  let minY = corners[0].y;
  let maxX = corners[0].x;
  let maxY = corners[0].y;

  for (let index = 1; index < corners.length; index += 1) {
    const point = corners[index];
    if (point.x < minX) minX = point.x;
    if (point.y < minY) minY = point.y;
    if (point.x > maxX) maxX = point.x;
    if (point.y > maxY) maxY = point.y;
  }

  return { minX, minY, maxX, maxY };
};
